import SelectRedux from "components/molecules/SelectRedux";
import DateRangePickerRedux from "components/molecules/DateRangePickerRedux";
import PageSize from "components/organisms/PageSize";
import { pageSize } from "utils/normalize.util";
import SelectYeloDriver from "components/organisms/SelectYeloDriver";
import SelectAssetCategory from "components/organisms/SelectAssetCategory";
import SelectAssetSubCategory from "components/organisms/SelectAssetSubCategory";
import { dateRangeFilter } from "utils/validate.util";

export { default } from "./AssetFilters";

export const fields: any[] = [
    {
        name: "driver_id",
        label: "Driver",
        component: SelectYeloDriver,
        cellProps: { md: 3 },
        ComboBoxProps: {
            multiple: false,
            options: []
        }
    },
    {
        name: "category_id",
        label: "Category",
        component: SelectAssetCategory,
        cellProps: { md: 3 },
        ComboBoxProps: { multiple: true, options: [] },
    },
    {
        name: "subcategory_id",
        label: "Subcategory",
        component: SelectAssetSubCategory,
        cellProps: { md: 3 },
        ComboBoxProps: { multiple: true, options: [] },
        componentProps: { form: "AssetFiltersForm" },
    },
    {
        name: "status",
        component: SelectRedux,
        label: "Status",
        SelectProps: {
            options: [
                { value: "active", label: "Active" },
                { value: "returned", label: "Returned" },
            ],
        },
        cellProps: { md: 3 },
    },
    {
        name: "date",
        label: "Date Range",
        validate: [dateRangeFilter],
        component: DateRangePickerRedux,
        cellProps: { md: 6 },
        DateRangePickerProps: {
            onChange: () => {},
            InputFieldProps: {},
            value: { date: ["", ""], error: ["", ""] },
        },
    },
    {
        name: "page_size",
        label: "Page Size",
        normalize: pageSize,
        component: PageSize,
        cellProps: { sm: 6, md: 3 },
        PageSizeProps: { form: "AssetFiltersForm" },
    },
];

